/* Ask Poppy (stylist v2) — chat UI.
   Security: every message is rendered with textContent; links and images from the API are only used
   when they point to this store / Shopify CDN. Cart adds go straight to Shopify (/cart/add.js). */
(function () {
  'use strict';
  var root = document.getElementById('jts');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var API = (root.dataset.api || '').replace(/\/$/, '');
  var MAX = 600;
  var STORE_KEY = 'jts-chat-v2';
  var $ = function (s) { return root.querySelector(s); };
  var openBtn = $('#jts-open'), panel = $('#jts-panel'), log = $('[data-log]'), scroller = $('[data-scroll]');
  var form = $('[data-form]'), input = $('[data-input]'), send = $('[data-send]'), count = $('[data-count]');
  var typing = $('[data-typing]'), typingText = $('[data-typing-text]'), welcome = $('[data-welcome]'), statusEl = $('[data-status]');
  var busy = false, lastSent = 0;

  // ---------- state (sessionStorage, this tab only) ----------
  function newId() {
    try { var a = new Uint8Array(12); crypto.getRandomValues(a); return 'jts_' + Array.prototype.map.call(a, function (b) { return b.toString(16).padStart(2, '0'); }).join(''); }
    catch (e) { return 'jts_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }
  }
  var state = { sessionId: newId(), messages: [] };
  try { var saved = JSON.parse(sessionStorage.getItem(STORE_KEY)); if (saved && /^jts_[A-Za-z0-9]+$/.test(saved.sessionId) && Array.isArray(saved.messages)) state = saved; } catch (e) {}
  function persist() { try { sessionStorage.setItem(STORE_KEY, JSON.stringify({ sessionId: state.sessionId, messages: state.messages.slice(-30) })); } catch (e) {} }

  // ---------- safe URL helpers ----------
  function safeProductUrl(u) {
    try { var url = new URL(u, location.origin); if (/^\/products\/[a-z0-9-]+$/.test(url.pathname)) return url.pathname; } catch (e) {}
    return null;
  }
  function safeImage(u) {
    try { var url = new URL(u, location.origin); if (url.protocol === 'https:' && /(^|\.)cdn\.shopify\.com$|^wear\.jirehthreads\.com$/.test(url.hostname)) { url.searchParams.set('width', '360'); return url.href; } } catch (e) {}
    return '';
  }
  var money = function (n) { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n); } catch (e) { return '$' + Number(n).toFixed(2); } };
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  // Turn plain text into nodes; only links to our own domains become clickable
  function richText(text) {
    var frag = document.createDocumentFragment();
    var re = /(https:\/\/(?:wear\.)?jirehthreads\.com\/[^\s)]*)/g, last = 0, m;
    while ((m = re.exec(text))) {
      frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      var a = el('a', null, m[1].includes('/tools/') ? 'Open tool ↗' : 'Open link');
      a.href = m[1]; a.rel = 'noopener'; if (!m[1].startsWith(location.origin)) a.target = '_blank';
      frag.appendChild(a); last = m.index + m[1].length;
    }
    frag.appendChild(document.createTextNode(text.slice(last)));
    return frag;
  }

  // ---------- rendering ----------
  function renderProducts(products) {
    var wrap = el('div', 'jts-cards');
    products.forEach(function (p) {
      var url = safeProductUrl(p.url);
      if (!url) return;
      var card = el('article', 'jts-card');
      var link = el('a', 'jts-card__img'); link.href = url; link.setAttribute('aria-label', p.title);
      var src = safeImage(p.image);
      if (src) { var img = el('img'); img.src = src; img.alt = ''; img.loading = 'lazy'; img.width = 180; img.height = 240; link.appendChild(img); }
      card.appendChild(link);
      var body = el('div', 'jts-card__b');
      var t = el('a', 'jts-card__t', p.title); t.href = url; body.appendChild(t);
      var pr = el('div', 'jts-card__p', money(p.price));
      if (p.compareAt) { var s = el('s', null, money(p.compareAt)); pr.appendChild(s); }
      body.appendChild(pr);
      var variants = (p.variants || []).filter(function (v) { return v && /^\d+$/.test(String(v.id)); });
      if (variants.length) {
        var row = el('div', 'jts-card__row');
        var sel = null;
        if (variants.length > 1 || (variants[0].title && variants[0].title !== 'Default Title')) {
          sel = el('select', 'jts-card__sel'); sel.setAttribute('aria-label', 'Choose size for ' + p.title);
          variants.forEach(function (v) { var o = el('option', null, v.title); o.value = v.id; sel.appendChild(o); });
          row.appendChild(sel);
        }
        var add = el('button', 'jts-card__add', 'Add'); add.type = 'button';
        add.addEventListener('click', function () { addToCart(sel ? sel.value : variants[0].id, add, p.title); });
        row.appendChild(add);
        body.appendChild(row);
      } else {
        body.appendChild(el('span', 'jts-card__out', 'Sold out'));
      }
      card.appendChild(body);
      wrap.appendChild(card);
    });
    return wrap;
  }

  function addMessage(m, animate) {
    if (welcome) welcome.hidden = true;
    var li = el('li', 'jts-msg jts-msg--' + m.role + (m.blocked ? ' is-guard' : '') + (animate ? ' is-new' : ''));
    if (m.role === 'assistant') li.appendChild(el('span', 'jts-avatar jts-avatar--sm', 'P')).setAttribute('aria-hidden', 'true');
    var col = el('div', 'jts-msg__col');
    var bubble = el('div', 'jts-bubble');
    if (m.blocked) {
      var tag = el('span', 'jts-guard', 'Kept safe by Jireh Threads');
      bubble.appendChild(tag);
    }
    var p = el('p'); p.appendChild(richText(m.content)); bubble.appendChild(p);
    col.appendChild(bubble);
    if (m.products && m.products.length) col.appendChild(renderProducts(m.products));
    if (m.followUps && m.followUps.length && animate) {
      var chips = el('div', 'jts-chips');
      m.followUps.forEach(function (f) { var b = el('button', 'jts-chip', f); b.type = 'button'; b.addEventListener('click', function () { chips.remove(); ask(f); }); chips.appendChild(b); });
      col.appendChild(chips);
    }
    li.appendChild(col);
    log.appendChild(li);
    scrollDown();
  }
  function scrollDown() { requestAnimationFrame(function () { scroller.scrollTop = scroller.scrollHeight; }); }

  // ---------- cart ----------
  function addToCart(variantId, btn, title) {
    if (!/^\d+$/.test(String(variantId))) return;
    btn.disabled = true; btn.textContent = '…';
    var body = new FormData();
    body.append('id', variantId); body.append('quantity', '1');
    body.append('sections', 'cart-drawer,cart-icon-bubble'); body.append('sections_url', location.pathname);
    fetch((root.dataset.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { btn.textContent = 'Sold out'; return; }
        btn.textContent = 'Added ✓';
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && res.sections && res.sections['cart-icon-bubble']) {
          var d = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (d) bubble.innerHTML = d.innerHTML; // Shopify-rendered markup from our own store
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') { drawer.classList.remove('is-empty'); close(); drawer.renderContents(res); }
        track('product_added', { title: String(title).slice(0, 80) });
      })
      .catch(function () { btn.textContent = 'Try again'; })
      .finally(function () { setTimeout(function () { btn.disabled = false; if (btn.textContent !== 'Added ✓') btn.textContent = 'Add'; }, 1500); });
  }

  // ---------- API ----------
  var hints = ['Thinking…', 'Searching the shop…', 'Styling your look…', 'Checking sizes…'];
  function ask(text) {
    text = String(text || '').replace(/\s+/g, ' ').trim().slice(0, MAX);
    if (!text || busy) return;
    var now = Date.now();
    if (now - lastSent < 1500) return;
    lastSent = now;
    if (!API) { addMessage({ role: 'assistant', content: 'The stylist is being set up. Please check back soon!' }, true); return; }

    var history = state.messages.slice(-10).map(function (m) { return { role: m.role, content: String(m.content).slice(0, 1200) }; });
    var userMsg = { role: 'user', content: text };
    state.messages.push(userMsg); persist(); addMessage(userMsg, true);
    input.value = ''; syncInput();

    busy = true; send.disabled = true; typing.hidden = false; scrollDown();
    var hi = 0, hintTimer = setInterval(function () { hi = (hi + 1) % hints.length; typingText.textContent = hints[hi]; }, 1800);
    var ctrl = new AbortController(), timer = setTimeout(function () { ctrl.abort(); }, 45000);

    fetch(API + '/chat', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, signal: ctrl.signal, credentials: 'omit',
      body: JSON.stringify({ sessionId: state.sessionId, message: text, history: history, context: root.dataset.product ? { productHandle: root.dataset.product } : {} })
    })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (b) { return { ok: r.ok, status: r.status, b: b }; }); })
      .then(function (res) {
        var b = res.b || {};
        var reply = typeof b.reply === 'string' && b.reply ? b.reply : (b.error && typeof b.error === 'string' ? b.error : 'Sorry, something went wrong. Please try again.');
        var msg = { role: 'assistant', content: reply.slice(0, 1200), products: Array.isArray(b.products) ? b.products.slice(0, 4) : [], followUps: Array.isArray(b.followUps) ? b.followUps.slice(0, 3).map(String) : [], blocked: !!b.blocked };
        state.messages.push({ role: 'assistant', content: msg.content, products: msg.products, blocked: msg.blocked }); persist();
        addMessage(msg, true);
        track('message_answered', { blocked: msg.blocked, products: msg.products.length });
      })
      .catch(function () { addMessage({ role: 'assistant', content: 'I couldn’t connect just now. Please check your connection and try again.' }, true); })
      .finally(function () { clearTimeout(timer); clearInterval(hintTimer); typingText.textContent = hints[0]; busy = false; typing.hidden = true; syncInput(); input.focus(); });
  }

  function track(type, data) {
    if (!API || !navigator.sendBeacon) return;
    try { navigator.sendBeacon(API + '/events', new Blob([JSON.stringify({ event_type: type, session_id: state.sessionId, data: data || {} })], { type: 'text/plain' })); } catch (e) {}
  }

  // ---------- open / close ----------
  function open() {
    panel.hidden = false; openBtn.setAttribute('aria-expanded', 'true'); root.classList.add('is-open');
    document.documentElement.classList.add('jts-lock');
    if (!log.children.length && state.messages.length) state.messages.forEach(function (m) { addMessage(m, false); });
    setTimeout(function () { input.focus(); scrollDown(); }, 60);
    track('chat_opened');
  }
  function close() {
    panel.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); root.classList.remove('is-open');
    document.documentElement.classList.remove('jts-lock'); openBtn.focus();
  }
  openBtn.addEventListener('click', function () { panel.hidden ? open() : close(); });
  $('[data-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
  $('[data-reset]').addEventListener('click', function () {
    state = { sessionId: newId(), messages: [] }; persist();
    log.textContent = ''; welcome.hidden = false; input.focus();
  });

  // Product-page shortcut
  var ctx = $('[data-ctx]');
  if (root.dataset.product && ctx) {
    ctx.hidden = false;
    ctx.textContent = 'Style this: ' + root.dataset.productTitle;
    ctx.addEventListener('click', function () { ask('How should I style the ' + root.dataset.productTitle + '? Is there a matching piece?'); });
  }
  root.querySelectorAll('[data-prompt]').forEach(function (b) { b.addEventListener('click', function () { ask(b.dataset.prompt); }); });

  // Public API: product pages can open Poppy with a question ready to send
  window.JTStylist = { open: open, ask: function (q) { if (panel.hidden) open(); setTimeout(function () { ask(String(q || '').slice(0, 600)); }, 120); } };

  // Let other parts of the theme open the stylist (product page "Ask the stylist" link)
  var legacy = document.createElement('button'); legacy.id = 'jireh-ai-open'; legacy.hidden = true; legacy.addEventListener('click', open); root.appendChild(legacy);

  // ---------- composer ----------
  function syncInput() {
    var n = input.value.length;
    count.textContent = n + '/' + MAX;
    count.classList.toggle('is-near', n > MAX * 0.9);
    send.disabled = busy || !input.value.trim();
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
  }
  input.addEventListener('input', syncInput);
  input.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); ask(input.value); } });
  form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); });
  if (!API) statusEl.textContent = 'Coming soon';
  syncInput();
})();
